<template lang="pug">
  transition(name='modal')
    .modal-mask(@click.self="closeModal()")
      .modal-wrapper(@click.self="closeModal()")
        .modal-container
          .modal-header
            p.title Aguardando distribuição
            el-button.btn#btn(
              type="text",
              @click="closeModal",
              @mouseover.native="hover",
              size="mini"
            )
              i.material-icons.icon close

          .modal-body
              el-row.pross
                p Processo:
                  b &nbsp {{ processo.numeroProcesso }}

              el-row.row
                p Selecione abaixo o perfil a ser vinculado o processo:
              app-label(label="Status:", style="margin-top: 20px")
              el-select.full-width(
                v-model='acao',
                placeholder='Selecione o perfil',
                class="select"
              )
                el-option(
                  v-for="task, index in tasks",
                  :key="task.valor",
                  :label="task.nome",
                  :value="task.valor"
                )
          .modal-footer
            slot(name="footer")
              el-button(@click="distribuirProcesso", type="primary") Confirmar

</template>

<script>

import {distribuirProcesso, trataAcoesDistribuirProcessos} from '@/utils/manutencao'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import { mapActions } from 'vuex'
export default {

  props: {
    processo: {
      require: true
    },
    tarefa: {
      require: true
    },
    mensagem: {
      require: true,
      default: ''
    },
    anexos: {
      type: Array
    },
    dados: {
      require: false
    }
  },

  data () {
    return {
      colorCopy: '#666666',
      hoverColor: '#079D67',
      tasks: [],
      acao: null,
      message: '',
      numProcesso: ''
    }
  },
  mixins: [
    AppNotificacao
  ],
  async mounted () {
    this.message = this.mensagem
    this.tasks = this.tarefa.acoes
    this.atualizarNomePerfilProtocolo()
    await this.trataTasksAmapa()
    this.numProcesso = this.processo.numeroProcesso
  },
  watch: {
    mensagem (value) {
      this.message = value
    }
  },
  methods: {
    ...mapActions({
      criarDespachoMovimentarProcesso: 'despacho/criarDespachoMovimentarProcesso',
      verificaExibicaoAcaoPresidenteSetorDipre: 'despacho/verificaExibicaoAcaoPresidenteSetorDipre'
    }),

    async distribuirProcesso () {
      if (this.acao === null || this.acao === undefined) {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'Escolha um setor!')
        return
      }
      const response = await distribuirProcesso(this.acao, this.tarefa.name, this.tarefa.acoes.length, this.numProcesso, this.processo.id, this.message, this.anexos)
      if (!response) this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'Erro ao mover processo, verifique sua conexão')
      else {
        if (this.isAmapa()) {
          await this.criarDespachoMovimentarProcesso(this.dados)
          this.dados.idProcesso = null
          this.dados.justificativa = ''
          this.dados.anexos = []
        }
        this.message = ''
        this.tasks = ''
        this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, 'Processo movido com sucesso')
        this.$emit('limparDados')
      }
    },
    atualizarNomePerfilProtocolo () {
      this.tasks = this.tasks.map(task => {
        if (task.nome === 'AGUARDANDO_ANALISE.AGENTE_ADMINISTRATIVO.PROTOCOLO') {
          return { ...task, nome: 'Agente Administrativo' }
        }
        return task
      })
    },
    closeModal () {
      if (this.acao === null || this.acao === undefined) {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'Selecione um perfil para mover o processo')
        return
      }

      this.$emit('limparDados')
    },
    hover () {
      this.colorCopy = this.hoverColor
    },
    isAmapa () {
      return process.env.ESTADO === 'ap'
    },
    async trataTasksAmapa () {
      const response = await trataAcoesDistribuirProcessos(this.processo.id, this.tasks)
      if (response) {
        this.tasks = response
      }
    }
  }
}

</script>

<style scoped lang="scss">

  .modal-mask {
    position: fixed;
    z-index: 8;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }

  .full-width {
    width: 95%;
  }

  .modal-wrapper {
    margin-top: 8vh;
  }

  .modal-container {
    min-height: 300px;
    max-height: 84vh;
    margin: 0px auto;
    background-color: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
    -moz-border-radius: 5px;
    -webkit-border-radius: 5px;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    max-width: 50%;
  }

  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color:#009f60;
    border-radius: 10px 10px 0 0;
    height: 55px;
  }

  .modal-body {
    padding: 10px;
    margin: 10px 30px;
    overflow-y: auto;
    max-height: 76vh;
    flex-grow: 1;
  }

  .modal-footer {
    display: flex;
    justify-content: flex-end;
    background-color: white;
    padding: 10px;
    border-radius: 0px 0px 10px 10px;
  }

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .title {
    margin: 0;
    font-size: 18px;
    color: white !important;
    font-weight: bold;
    padding: 0 10px;
    margin-bottom: 0px !important;
  }

  .btn {
    padding-right: 20px;
    color: white;

    .icon {
      font-size: 18px;
    }
  }

  .pross {
    margin-top: 20px;
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/screens/manutencao/components/modal/AppModalDistribuicao.vue